export const environment = {
  production: false,
  version: '5.3.0',
  mockData: false,
  apiUrl: 'https://stage-tg-api.starexchange.dev',
  hasDarkTheme: false,
  devMode: true,
  linkWebVersion: 'https://aml-stage.starexchangealliance.com'
};
